import React from "react";
import { useParams } from "react-router-dom";

const RentalList = ({ rentals }) => {
  const { lang } = useParams();

  if (!rentals || rentals.length === 0) {
    return <p>No rental cars available.</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {rentals.map((rental) => (
        <div key={rental._id} className="border p-4 rounded-lg shadow-md">
          <img
            src={rental.vehicle.primaryImage || rental.images?.[0]}
            alt={rental.vehicle.title}
            className="w-full h-48 object-cover rounded-md"
          />
          <h2 className="text-lg font-semibold mt-2">
            {rental.vehicle.brand} {rental.vehicle.model} ({rental.vehicle.year})
          </h2>
          <p className="text-sm text-gray-600 mt-2">
            {rental.rentalTerms?.[lang] || rental.rentalTerms?.en || "Terms not available."}
          </p>
          <div className="mt-2 flex justify-between items-center">
            <span className="text-green-600 font-bold">
              {rental.pricePerDay} CFA / day
            </span>
            <span
              className={`text-sm px-2 py-1 rounded ${
                rental.availability ? "bg-green-500" : "bg-red-500"
              } text-white`}
            >
              {rental.availability ? "Available" : "Not Available"}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RentalList;
